<template>
  <div class="col">
    <div v-if="isStart" class="top-left-cover-line" />
    <div v-if="isEnd" class="top-right-cover-line" />
    <div v-if="isStart" class="bottom-left-cover-line" />
    <div v-if="isEnd" class="bottom-right-cover-line" />
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    isStart: {
      type: Boolean,
      default: false
    },
    isEnd: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
@mixin layCenter {
  display: flex;
  align-items: center;
  justify-content: center;
}
@mixin line {
  position: absolute;
  height: 3px;
  width: 50%;
  background-color: #f0f2f5;
}
.col {
  width: 100%;
  display: flex;
  align-items: stretch;
  justify-content: flex-start;
  flex-flow: column nowrap;
  position: relative;
  background-color: #f0f2f5;
}
.col::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 0;
    margin: auto;
    width: 2px;
    height: 100%;
    background-color: #CACACA;
}
.top-left-cover-line {
 @include line;
  top: -2px;
  left: -1px;
}
.top-right-cover-line {
  @include line;
  top: -2px;
  right: -1px;
}
.bottom-left-cover-line {
  @include line;
  bottom: -2px;
  left: -1px;
}
.bottom-right-cover-line {
  @include line;
  bottom: -2px;
  right: -1px;
}
</style>
